import * as React from 'react';
/** @hidden */
export var usePrevious = function (value) {
    var ref = React.useRef();
    React.useEffect(function () {
        ref.current = value;
    });
    return ref.current;
};
//# sourceMappingURL=usePrevious.js.map